<template>
	<div class="topUp" @click="close()">
		<div class="topUpCon" @click.stop="">
			<div class="topUpContainer">
				<div class="title">
					准币充值
				</div>
				
				<div class="gear" v-if="step==1">
					<div v-for="(item,index) of gearLi" :key="index" class="li" :class="{'select':gearId==item.id}"  @click="choosePay(item.id)">
						<div class="num">
							{{item.num}}元
						</div>
						<div class="unit">
							{{item.num}}准币
						</div>
					</div>
				</div>
				
				<div class="codebox" v-if="step==2">
					<el-image class="img" :src="require('@/static/pay-code.png')"></el-image>	
					<div class="text">如出现异常或准币未到账，请联系客服</div>
					<div class="text">客服联系电话：<span> 400 - 101 - 8699</span></div>
				</div>
				
				<div class="button" @click="orderPay(2)" v-if="step==1">确认支付</div>
				<div class="button" @click="orderPay(1)" v-if="step==2">返回</div>
				<div class="agreement">
					* 付款即表示同意 <span @click="toAgreement()">《准聘增值服务协议》</span>
				</div>
			</div>
		    <img src="@/static/close.png" class="close" @click="close()" />
		</div>
	</div>
</template>

<script>
	export default {
		name:'topUp',
		data() {
			return {
				step:1,
				gearId:1,
				gearLi:[
					{ num:98, id:1 },
					{ num:99, id:2 },
					{ num:100, id:3 },
					{ num:1000, id:4 },
					{ num:2000, id:5 },
					{ num:3000, id:6 },
				]
			}
		},
		created() {
			document.body.style.overflow = 'hidden';
		},
		beforeDestroy() {
			document.body.style.overflow = 'visible';
		},
		methods: {
			toAgreement(){
				this.$router.push({ name: 'agreement',query:{type:5} });
				this.close()
			},
			orderPay(step){
				this.step = step
				// this.$eltips('充值暂未开放','warning')
			},
			choosePay(id){
				this.gearId = id
			},
			close(){
				this.$store.commit('changeTopUpDialog',false);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.topUp {
		width: 100%;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		position: fixed;
		z-index: 999;
		top: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.topUpCon {
		width: 474px;
		box-sizing: border-box;
		border-radius: 32px;
		position: relative;
		padding: 42px;
		box-sizing: border-box;
		// background-color: #fff;
		background: linear-gradient(169deg, #63CBCB 0%, #FFFFFF 20%);
		.close{
			position: absolute;
			z-index: 2;
			right: 28px;
			top:28px;
			cursor: pointer;
		}
	
		.topUpContainer {
			position: relative;
			z-index: 2;
			display: flex;
			// align-items: center;
			// justify-content: space-between;
			height: 100%;
			flex-direction: column;
			.title {
				color: #151515;
				font-size: 18px;
				margin-bottom: 18px;
				font-weight: bold;
			}
			
			.gear{
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				margin-bottom: 18px;
				.li{
					width: 122px;
					margin-right: 12px;
					&:nth-child(3n){
						margin-right: 0;
					}
					height: 81px;
					background: #F5F5F5;
					border: 1px solid #F5F5F5;
					border-radius: 8px;
					display: flex;
					align-items: center;
					flex-direction: column;
					justify-content: space-between;
					padding: 14px 0;
					box-sizing: border-box;
					margin-bottom: 11px;
					cursor: pointer;
					.num{
						font-size: 18px;
						color: #151515;
						// font-weight: bold;
					}
					.unit{
						color: #868686;
						font-size: 16px;
					}
				}
				.select{
					border-color: #51A190;
					.num{
						color: #51A190;
						font-weight: bold;
					}
				}
			}
			
			.codebox{
				text-align: center;
				margin-bottom: 18px;
				.img{
					width: 200px;
					height: 200px;
				}
				.text{
					margin-top: 8px;
					font-size: 14px;
					span{
						color: #51A190;
					}
				}
			}
			
			.button {
				margin-bottom: 12px;
				width: 388px;
				line-height: 45px;
				background-color: #51A190;
				color: #fff;
				border-radius: 8px;
				font-size: 16px;
				text-align: center;
				cursor: pointer;
			}
	
			.agreement {
				color: #A3A7B3;
				font-size: 14px;
				span {
					cursor: pointer;
					color: #51A190;
				}
			}
		}
	
	}
</style>